function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import tokens from '@veneer/tokens';
import { system as defaultSystem } from '@veneer/system';
import defaultTheme from '../default_theme';
function getSupportedMode(mode) {
  return mode === 'contrast' ? 'highContrast' : mode;
}
function getDefaultMode(mode) {
  switch (mode) {
    case 'light':
    case 'dark':
      return mode;
    case 'contrast':
      return 'highContrast';
    default:
      return 'light';
  }
}
export default function createTheme(_ref) {
  var _customSystem$level, _customSystem$palette;
  var {
    density = 'standard',
    mode = 'light',
    outerTheme = {},
    shape = 'round',
    customSystem
  } = _ref;
  var supportedMode = getSupportedMode(mode);
  var defaultMode = getDefaultMode(mode);
  var level = (customSystem === null || customSystem === void 0 || (_customSystem$level = customSystem.level) === null || _customSystem$level === void 0 ? void 0 : _customSystem$level[supportedMode]) || defaultSystem.level[defaultMode];
  var palette = (customSystem === null || customSystem === void 0 || (_customSystem$palette = customSystem.palette) === null || _customSystem$palette === void 0 ? void 0 : _customSystem$palette[supportedMode]) || defaultSystem.palette[defaultMode];
  var densityVars = defaultTheme.density[density];
  var shapeVars = defaultTheme.shape[shape] || {};
  if (Object.keys(outerTheme).length > 0) {
    densityVars = _objectSpread(_objectSpread({}, densityVars), outerTheme.density ? outerTheme.density[density] : {});
    shapeVars = _objectSpread(_objectSpread({}, shapeVars), outerTheme.shape ? outerTheme.shape[shape] : {});
  }
  return _objectSpread(_objectSpread(_objectSpread({
    density,
    elevation: defaultTheme.elevation,
    level,
    mode,
    palette,
    shape
  }, tokens), densityVars), shapeVars);
}